export function sanitizeFilename(input: string): string {
    // This regex removes control characters (code points 0–31) which are invalid in filenames on the different platforms.
    // While valid in JavaScript strings, they must be sanitized to prevent file system issues.
    // eslint-disable-next-line no-control-regex
    const invalidChars = /[<>:"/\\|?*\u0000-\u001F]/g;
    const reservedNames = /^(con|prn|aux|nul|com\d|lpt\d)$/i;

    const trimmed = input.trim().replace(invalidChars, "").replace(/^\.+/, "").replace(/\.+$/, "");
    const safe = trimmed.length > 0 ? trimmed : "email";

    // Avoid reserved Windows filenames
    if (reservedNames.test(safe)) {
        return `_${safe}`;
    }

    // Prevent filenames starting with `.`, which makes them hidden on Unix-based systems
    return safe.startsWith(".") ? `_${safe}` : safe;
}
